const Footer = () => {
    return (
        <footer style={{ backgroundColor: 'rgba(0,0,0,0.7)', color: 'white', textAlign: 'center', padding: '20px', height: '100px' }}>
            <h1 style={{ marginTop: '20px', marginBottom:'auto' }}>© 2024 Everbright Solutions, LLC. All rights reserved</h1>
        </footer>
    );
};

export default Footer;
